var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServiceIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1009 4.54689C16.5109 5.50415 16.6112 6.56565 16.3879 7.58278C16.1646 8.59991 15.6288 9.52175 14.8556 10.2192C14.0823 10.9167 13.1103 11.3549 12.0756 11.4725C11.0409 11.5901 9.99534 11.3812 9.08528 10.875L4.70247 15.9531C4.35023 16.3054 3.87249 16.5033 3.37435 16.5033C2.8762 16.5033 2.39846 16.3054 2.04622 15.9531C1.69398 15.6009 1.49609 15.1232 1.49609 14.625C1.49609 14.1269 1.69398 13.6491 2.04622 13.2969L7.12435 8.91408C6.61817 8.00402 6.40925 6.95846 6.52684 5.92377C6.64443 4.88907 7.08265 3.91705 7.78013 3.14379C8.47762 2.37053 9.39945 1.83474 10.4166 1.61143C11.4337 1.38813 12.4952 1.48848 13.4525 1.89846L10.1712 5.17189L10.6165 7.38283L12.8275 7.82814L16.1009 4.54689Z",
    stroke: "#C9C9C9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceIcon);
export default __webpack_public_path__ + "static/media/ServiceIcon.20392142153a5fcc4a7a4bcc7b83d2f4.svg";
export { ForwardRef as ReactComponent };